var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewMeetingButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_15536",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 15536",
    transform: "translate(-446 -626)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_15535",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 15535",
    transform: "translate(-135 44)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_9550",
    "data-name": "\\u9577\\u65B9\\u5F62 9550",
    width: 82,
    height: 82,
    transform: "translate(581 582)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_21247",
    "data-name": "\\u30D1\\u30B9 21247",
    d: "M454.495,173.588a19.532,19.532,0,1,0-26.416,18.281,11.335,11.335,0,0,0-3.724,5.652,1.953,1.953,0,1,0,3.782.979,7.954,7.954,0,0,1,1.483-2.7,7.7,7.7,0,0,1,11.346,0,7.968,7.968,0,0,1,1.48,2.684,1.953,1.953,0,0,0,3.785-.966,11.348,11.348,0,0,0-3.944-5.826A19.533,19.533,0,0,0,454.495,173.588ZM442.7,181.325a1.953,1.953,0,0,1-2.763,0l-12.905-12.9a1.953,1.953,0,1,1,2.762-2.762L442.7,178.563A1.953,1.953,0,0,1,442.7,181.325Z",
    transform: "translate(31.57 491.385)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_21248",
    "data-name": "\\u30D1\\u30B9 21248",
    d: "M454.495,173.588a19.532,19.532,0,1,0-26.416,18.281,11.335,11.335,0,0,0-3.724,5.652,1.953,1.953,0,1,0,3.782.979,7.954,7.954,0,0,1,1.483-2.7,7.7,7.7,0,0,1,11.346,0,7.968,7.968,0,0,1,1.48,2.684,1.953,1.953,0,0,0,3.785-.966,11.348,11.348,0,0,0-3.944-5.826A19.533,19.533,0,0,0,454.495,173.588ZM442.7,181.325a1.953,1.953,0,0,1-2.763,0l-12.905-12.9a1.953,1.953,0,1,1,2.762-2.762L442.7,178.563A1.953,1.953,0,0,1,442.7,181.325Z",
    transform: "translate(73.377 491.385)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMeetingButton);
export default __webpack_public_path__ + "static/media/newMeetingButton.41fca98d23e866470158677732e5b2cc.svg";
export { ForwardRef as ReactComponent };